export default "__VITE_ASSET__DWnHWTDb__"